import Swal from "sweetalert2";

export const ALERT = Swal.mixin({
  toast: true,
  position: "top-end",
  showConfirmButton: false,
  timer: 3000,
  timerProgressBar: true,
  didOpen: (toast) => {
    toast.addEventListener("mouseenter", Swal.stopTimer);
    toast.addEventListener("mouseleave", Swal.resumeTimer);
  },
});

//Base URL para mostrar tracking al cliente
export const BASE_URL_TRACKING =
  "https://portalunificado.titancemento.com/tracking";

//export const BASE_URL = "http://200.7.103.243:5986";
export const BASE_URL =
  process.env.REACT_APP_ENVIRONMENT === "PROD"
    ? process.env.REACT_APP_BASE_URL_PROD
    : process.env.REACT_APP_BASE_URL_DEV;
//export const BASE_URL = "http://172.24.10.84:4000";
export const URL_APP = process.env.REACT_APP_URL_APP;
//export const API_KEY = "AIzaSyDS7WoBKpQ6D27eTXf--31rKAVFQib_cz8";
export const API_KEY = process.env.REACT_APP_API_KEY;
export const API_KEY_MAPS = process.env.REACT_APP_API_KEY_MAPS;

console.log(process.env.REACT_APP_ENVIRONMENT);

//Función para buscar un valor en un array de objetos
export const searchObjectByValue = (obj, value) => {
  if (typeof obj === "object" && obj !== null) {
    for (const key in obj) {
      if (obj[key] === value) {
        return obj;
      } else if (typeof obj[key] === "object") {
        const result = searchObjectByValue(obj[key], value);
        if (result) {
          return result;
        }
      }
    }
  }
  return null;
};

export const initForms = {
  initOperators: [
    {
      codeOperator: "",
      nameOperator: "",
      position: "",
    },
  ],
  initProduction: {
    codeProduct: "",
    nameProduct: "",
    quantity: "",
    enterTime: "",
    trayProduct: "",
    operators: [],
  },
  initDownTime: {
    startTime: "",
    endTime: "",
    cause: "",
    detail: "",
    observation: "",
    enterTime: "",
  },
  initObservations: {
    observationReport: "",
    enterTime: "",
  },
  initOperator: {
    codeOperator: "",
    nameOperator: "",
    position: "",
  },
};

export default function convertString(inputString) {
  const words = inputString.split(" ");

  const result = words.map((word) => {
    const firstLetter = word.charAt(0).toUpperCase();
    const restLetters = word.substring(1).toLowerCase();
    return firstLetter + restLetters;
  });

  return result.join(" ");
}

export const listPositions = [
  "Operario",
  "Supervisor",
  "Soldador",
  "Ayudante",
  "Mecánico",
  "Eléctrico",
  "Montacarguista",
  "Asistente de Ingeniería",
  "Asistente de Producción",
  "Ingeniero de Desarrollo",
  "Director de Sistemas",
  "Soporte de Sistemas",
];

export const tittleToExcel = {
  codeProduct: "Referencia",
  nameProduct: "Descripción",
  weightProduct: "Peso Kg.",
  d01: "D01",
  d02: "D02",
  d03: "D03",
  d04: "D04",
  d05: "D05",
  d06: "D06",
  d07: "D07",
  d08: "D08",
  d09: "D09",
  d10: "D10",
  d11: "D11",
  d12: "D12",
  d13: "D13",
  d14: "D14",
  d15: "D15",
  d16: "D16",
  d17: "D17",
  d18: "D18",
  d19: "D19",
  d20: "D20",
  d21: "D21",
  d22: "D22",
  d23: "D23",
  d24: "D24",
  d25: "D25",
  d26: "D26",
  d27: "D27",
  d28: "D28",
  d29: "D29",
  d30: "D30",
  d31: "D31",
};

export const months = [
  "Ene",
  "Feb",
  "Mar",
  "Abr",
  "May",
  "Jun",
  "Jul",
  "Ago",
  "Sep",
  "Oct",
  "Nov",
  "Dic",
];

export const titleToDownTime = {
  codeMachine: "Máquina",
  shiftTime: "Turno",
  startTime: "Hora Inicio",
  endTime: "Hora Final",
  cause: "Causa",
  detail: "Detalle",
  observation: "Observación",
};
export const titleToDownTimeDecoblock = {
  subMachines: "Máquina",
  shiftTime: "Turno",
  startTime: "Hora Inicio",
  endTime: "Hora Final",
  cause: "Causa",
  detail: "Detalle",
  observation: "Observación",
};

export const dcbck = "Decoblock";
export const tt = "Titan";
export const ctHeadquarter = "COTA";
export const slHeadquarter = "SOLEDAD";
export const gdHeadquarter = "GIRARDOTA";

//Permisos de calidad para reportes de producción
export const permissionsOptions = "show_qa_options";
export const superAdminQaPermission = "show_super_admin_qa";

//Permisos para DEVOLUCIONES
export const permissReturns = {
  superAdmin: "rt_superAdmin_Show",
  usersReturns: "rt_usersReturns_Show",
  ncPermissQa: "rt_nc_add_Report",
  superAdminQaPermiss: "rt_qa_superAdmin_Show",
  superAdminLogistic: "super_admin_edit_returns",
};

//Permisos de Nc Patio
export const permissNcPatio = {
  userNcPatio: "show_nc_patio_form",
  superAdminNcPatio: "super_admin_nc_patio",
};

//Permisos de Armaduras
export const permissArmatures = {
  superAdminArmatures: "superadmin_da_Report",
  usersArmatures: "da_add_Report",
};

//Permisos de producción
export const permissProduction = {
  superAdminProduction: "rp_super_admin",
};

export const permissIdentificationSystem = {
  superAdminIdentSystem: "super_admin_si",
};
//Permisos de fichas técnicas
export const permissTechnicalSheet = {
  superAdminTechnicalSheet: "super_admin_technical_sheet",
  usersTechnicalSheet: "ts_user_current",
  generalAdminTech: "general_super_admin_tech",
  approvGeneralBudget: "approv_general_budgets", //Aprobar los presupuestos generales
};

export const permissBiometricDecoblock = {
  superAdminBiometric: "super_admin_biometric_deco",
  onlyReadBiometric: "only-read-biometric-app",
};

export const permissRecipes = {
  superAdminRecipes: "super_admin_recipes",
  onlyReadRecipes: "only-read-recipes-app",
};

export const permissSkako = {
  superAdminSkako: "super-admin-permiss",
  onlyReadSkako: "only-read-skako-app",
};

export const permissShiftProgram = {
  superAdminShiftProgram: "super_admin_shift_program",
  onlyReadShiftProgram: "only_read_shift_program",
};

export const permissSstControl = {
  superAdminSstControl: "super-admin-sst",
  onlyReadSstControl: "only_read_sst",
};

export const permissInventory = {
  superAdminInventory: "super_admin_inventory",
  onlyReadInventory: "only_read_inventory",
  counters: "counters_inventory",
};

export const permissDispatchFormat = {
  superAdminDispatchFormat: "super_admin_dispatch_format",
  onlyReadDispatchFormat: "only_read_dispatch_format",
  uploaderFile: "uploader_file_dispatch_format",
};

export const permissBudgetSystem = {
  superAdminBudgetSystem: "super_admin_budget_system",
  onlyReadBudgetSystem: "only_read_budget_system",
};

export const permissDispatch = {
  cartera: "user_cartera",
  dispatch: "user_dispatch",
};

export const permissQaCertificates = {
  superAdminQaCertificates: "super_admin_permiss",
  onlyReadQaCertificates: "only_read_qa_certificates",
  reviewer: "reviewer_qa_certificates",
  signerApprover: "signer_approver_qa_certificates",
};

//AREAS PARA DEVOLUCIONES
export const areas = {
  production: "PRODUCCION",
  qa: "CALIDAD",
  logistic: "LOGISTICA",
  admin: "ADMIN",
  destajos: "DESTAJOS",
  commercial: "COMERCIAL",
  account: "CARTERA",
  inventory: "INVENTARIO",
  technical: "TECNICA",
  withoutArea: "SIN AREA",
  qaInspector: "ASEGURADOR",
};

//ESTADOS DE REPORTE PARA DEVOLUCIONES
export const stateRT = {
  pending: "EN REVISION",
  qaReview: "REVISADO POR CALIDAD",
  inventoryReview: "REVISADO POR INVENTARIO",
  approved: "APROBADO",
  rejected: "RECHAZADO",
  canceled: "ANULADO",
  closed: "CERRADO",
  revised: "REVISADO",
  revisedDispatch: "REVISADO POR DESPACHOS",
};

export const pastelColors = [
  "#FFB6C1", // Light Pink
  "#87CEEB", // Sky Blue
  "#98FB98", // Pale Green
  "#FFA07A", // Light Salmon
  "#ADD8E6", // Light Blue
  "#F0E68C", // Khaki
  "#90EE90", // Light Green
  "#FFC0CB", // Pink
  "#B0E0E6", // Powder Blue
  "#FFDEAD", // Navajo White
  "#00CED1", // Dark Turquoise
  "#FFE4E1", // Misty Rose
  "#FAFAD2", // Light Goldenrod Yellow
  "#FF6347", // Tomato
  "#D2B48C", // Tan
  "#7B68EE", // Medium Slate Blue
  "#F08080", // Light Coral
  "#E6E6FA", // Lavender
  "#FFFACD", // Lemon Chiffon
  "#DDA0DD", // Plum
  "#F5DEB3", // Wheat
  "#AFEEEE", // Pale Turquoise
  "#FF00FF", // Magenta
  "#FFEFD5", // Papaya Whip
  "#FFDAB9", // Peach Puff
];

//fecha para enterTime hora de registro de alguna acción "AAAA-MM-DD HH:MM:SS"
export const getEnterTime = () => {
  const date = new Date();
  const year = date.getFullYear();
  const month = (date.getMonth() + 1).toString().padStart(2, "0");
  const day = date.getDate().toString().padStart(2, "0");
  const hour = date.getHours().toString().padStart(2, "0");
  const minute = date.getMinutes().toString().padStart(2, "0");
  const secound = date.getSeconds().toString().padStart(2, "0");
  const dateToSend = `${year}-${month}-${day} ${hour}:${minute}:${secound}`;
  return dateToSend;
};

export const convertDate = (date) => {
  const year = date.getFullYear();
  const month = (date.getMonth() + 1).toString().padStart(2, "0");
  const day = date.getDate().toString().padStart(2, "0");
  const dateToSend = `${year}-${month}-${day}`;
  return dateToSend;
};

//Funcion para obtener la fecha actual aaaa-mm-dd
export const getCurrentDate = () => {
  const date = new Date();
  const year = date.getFullYear();
  const month = (date.getMonth() + 1).toString().padStart(2, "0");
  const day = date.getDate().toString().padStart(2, "0");
  const dateToSend = `${year}-${month}-${day}`;
  return dateToSend;
};

//Funcion para obtener en dia de ayer aaa-mm-dd
export const getYesterday = () => {
  const date = new Date();
  const year = date.getFullYear();
  const month = (date.getMonth() + 1).toString().padStart(2, "0");
  const day = (date.getDate() - 1).toString().padStart(2, "0");
  const dateToSend = `${year}-${month}-${day}`;
  return dateToSend;
};

//Permisos llamados exactamente igual que los nombres de las
//tablas de la base de datos
export const permissAplications = {
  armatures: "da_sys_Permiss",
  returns: "rt_sys_Permiss",
  ncPatio: "nc_sys_Permiss",
  accountProviders: "ap_sys_Permiss",
  production: "rp_sys_Permiss",
  identificationSystem: "si_sys_Permiss",
  technicalSheet: "ts_sys_Permiss",
  purchaseOrder: "ap_sys_Permiss",
  biometricDecoblock: "bio_sys_Permiss",
  recipes: "rc_sys_Permiss",
  skako: "sk_sys_Permiss",
  shiftProgram: "sp_sys_Permiss",
  sstControl: "sst_sys_Permiss",
  budgetSystem: "bgs_sys_Permiss",
  dispatchFormat: "df_sys_Permiss",
  inventory: "inv_sys_Permiss",
  dispatchRem: "rd_sys_Permiss",
  qaCertificates: "cqa_sys_Permiss",
};

export const statesBugdet = {
  creating: "EN CREACION",
  closed: "CERRADO-VENDIDO",
  losePrice: "PERDIDO - PRECIO",
  loseDelivery: "PERDIDO - PLAZO DE ENTREGA",
  loseLatelly: "PERDIDO - DEMORA A. T.",
  loseNoAdjudicated: "PERDIDO - NO ADJUDICADO",
  clientReview: "REVISION DEL CLIENTE",
  clarificationCommercial: "ACLARACION COMERCIAL",
  createdBudget: "PRESUPUESTO REALIZADO",
  budgetReview: "REVISION DEL PRESUPUESTO",
  actualization: "ACTUALIZACION",
  offer: "OFERTADO",
  rejected: "DESCARTADO",
  techClarification: "ACLARACION TECNICA",
  rejectedBudget: "DESCARTADO",
};

export const getRangeCement = (cement) => {
  if (cement >= 200 && cement <= 900) {
    return String(Math.floor((cement - 200) / 20) * 2 + 20);
  }
};

export const formatDate = (dateString) => {
  const date = new Date(dateString);
  const day = String(date.getUTCDate()).padStart(2, "0");
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const year = date.getFullYear();

  return `${year}-${month}-${day}`;
};

//obtener hora hh:mm
export const formatHour = (dateString) => {
  const date = new Date(dateString);
  const hour = String(date.getHours()).padStart(2, "0");
  const minute = String(date.getMinutes()).padStart(2, "0");

  return `${hour}:${minute}`;
};

export const statesSSTControl = {
  rejected: "RECHAZADO",
  pending: "PENDIENTE POR APROBAR",
  approved: "APROBADO",
  missfiles: "FALTAN ARCHIVOS",
  unstate: "REVISAR",
};

export const getDocumentStatus = (operators) => {
  let hasRejected = false;
  let hasMissingFiles = false;
  let hasPending = false;
  let allApproved = true; // Asumimos que todos están aprobados, y lo cambiamos si encontramos un estado diferente

  operators.forEach((operator) => {
    operator.service.docsTypes.forEach((doc) => {
      if (doc.stateDoc === false) {
        hasRejected = true; // Prioridad más alta
      } else if (!doc.filename || !doc.startDate || !doc.endDate) {
        hasMissingFiles = true;
      } else if (doc.stateDoc === null) {
        hasPending = true;
      } else if (doc.stateDoc !== true) {
        allApproved = false; // Si algún documento no está aprobado, desmarcamos `allApproved`
      }
    });
  });

  // Retornamos el estado que tenga mayor prioridad
  if (hasRejected) {
    return statesSSTControl.rejected;
  } else if (hasMissingFiles) {
    return statesSSTControl.missfiles;
  } else if (hasPending) {
    return statesSSTControl.pending;
  } else if (allApproved) {
    return statesSSTControl.approved;
  } else {
    return statesSSTControl.unstate;
  }
};

export const stateDocs = (docs) => {
  if (!docs) return "Cargando...";
  const hasRejected = docs.some((doc) => doc.stateDoc === false);
  if (hasRejected) return "RECHAZADO";

  const hasPending = docs.some((doc) => doc.stateDoc === null);
  if (hasPending) return "PENDIENTE";

  const allApproved = docs.every((doc) => doc.stateDoc === true);
  if (allApproved) return "APROBADO";
};

export const stateSurveillance = (docs) => {
  if (!docs) return "Cargando...";
  const hasRejected = docs.some((doc) => doc.stateDoc === false);
  if (hasRejected) return "DESAUTORIZADO";

  const hasPending = docs.some((doc) => doc.stateDoc === null);
  if (hasPending) return "DESAUTORIZADO";

  const allApproved = docs.every((doc) => doc.stateDoc === true);
  if (allApproved) return "AUTORIZADO";
};

export const apps = {
  armatures: "da",
  returns: "returns",
  ncPatio: "ncPatio",
  accountProviders: "accountProviders",
  production: "production",
  identificationSystem: "identificationSystem",
  technicalSheet: "technicalSheet",
  purchaseOrder: "purchaseOrder",
  biometricDecoblock: "biometricDecoblock",
  recipes: "recipes",
  skako: "skako",
  shiftProgram: "shiftProgram",
  sstControl: "sstControl",
};
